<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">Britain’s Railways in the Second World War</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?39cc25c4